import { requestAppHandoffToken } from '@/lib/auth/app-handoff';
import { buildNativeAppDeepLink, buildAndroidIntentDeepLink } from '@/lib/auth/native-app-deep-link';
import { isWebReturnToAppFlow } from '@/lib/auth/web-onboarding-return-to-app';
import { Platform } from 'react-native';

function isAndroidWeb(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android/i.test(navigator.userAgent);
}

/** URLs para <a href> — geradas antes do clique (Safari exige gesto síncrono). */
export async function prepareReturnToAppLinks(): Promise<{
  schemeUrl: string | null;
  openUrl: string | null;
}> {
  if (Platform.OS !== 'web') {
    return { schemeUrl: null, openUrl: null };
  }

  const handoffToken = await requestAppHandoffToken();
  const path = 'auth/callback';
  const params = handoffToken ? { handoff: handoffToken } : undefined;

  if (handoffToken) {
    const schemeUrl = buildNativeAppDeepLink(path, params);
    const openUrl = isAndroidWeb()
      ? buildAndroidIntentDeepLink(path, params)
      : schemeUrl;
    return { schemeUrl, openUrl };
  }

  if (!isWebReturnToAppFlow()) {
    return { schemeUrl: null, openUrl: null };
  }

  const schemeUrl = buildNativeAppDeepLink('login', { registered: '1' });
  const openUrl = isAndroidWeb()
    ? buildAndroidIntentDeepLink('login', { registered: '1' })
    : schemeUrl;
  return { schemeUrl, openUrl };
}
